export default __webpack_public_path__ + "media/images/dashboard_icons/pencil-2b3a8ce77249e213462e355815aeba2c.svg";